import { FormControlLabelClassKey } from '@material-ui/core/FormControlLabel';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const THDFormControlLabelStyles: Partial<
  Record<FormControlLabelClassKey, CSSProperties>
> = {
  root: {
    fontSize: '1.2rem',
    marginLeft: '0px',
    marginRight: '0px',
    '-webkit-touch-callout': 'none',
    '-webkit-user-select': 'none',
    '-khtml-user-select': 'none',
    '-moz-user-select': 'none',
    '-ms-user-select': 'none',
    userSelect: 'none',
  },
};
